import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import Button from '../ui/Button';
import { useUserCount } from '../../hooks/useUserCount';
import horizontalVideo from '../../assets/images/horizontal_eyes_hero.mp4';
import verticalVideo from '../../assets/images/vertical_eyes_hero.mp4';

const Hero = () => {
  const [opacity, setOpacity] = useState(1);
  const navigate = useNavigate();
  const { userCount, loading: userCountLoading } = useUserCount();

  useEffect(() => {
    const handleScroll = () => {
      const hero = document.querySelector('.hero');
      if (!hero) return;
      const heroHeight = hero.offsetHeight;
      const scrollY = window.scrollY;
      // Fade out over the first 60% of the hero height
      const fadeStart = 0;
      const fadeEnd = heroHeight * 0.6;
      let newOpacity = 1;
      if (scrollY > fadeStart) {
        newOpacity = 1 - Math.min((scrollY - fadeStart) / (fadeEnd - fadeStart), 1);
      }
      setOpacity(newOpacity);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleStartDesigning = () => {
    navigate('/design');
  };

  return (
    <section className="hero" style={{ opacity }}>
      <video 
        className="hero-video hero-video-desktop"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src={horizontalVideo} type="video/mp4" />
      </video>
      <video 
        className="hero-video hero-video-mobile"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src={verticalVideo} type="video/mp4" />
      </video>
      <div className="hero-content">
        <h1>don't be seen</h1>
        <p className="hero-subtitle">
          Personalized camouflage built from your local landscape.
        </p>
        <div className="hero-actions">
          <Button variant="primary" className="large" onClick={handleStartDesigning}>
            Start Designing
          </Button>
        </div>
        <div className="user-count">
          {!userCountLoading && (
            <p className="member-count">
              {userCount.toLocaleString()} MEMBERS INDOCTRINATED
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero; 